import { render, staticRenderFns } from "./KegiatanAdd.vue?vue&type=template&id=04a3e92c&scoped=true"
import script from "./KegiatanAdd.vue?vue&type=script&lang=js"
export * from "./KegiatanAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a3e92c",
  null
  
)

export default component.exports